const labels = () => ({
	default: "en",
	icon: {
		arrowleft: "←",
		arrowright: "→",
		attach: "📄",
		back: "◀︎",
		cancel: "↖︎",
		close: "✕",
		create: "✚",
		delete: "✕",
		edit: "📝",
		down: "▼",
		"down-alt": "▽",
		forward: "▶︎",
		injection: "🩼",
		lock: "🔓",
		network: "⇄",
		ok: "✔︎",
		pause: "||",
		reload: "↺",
		stop: "◼︎",
		trash: "🗑️",
		up: "▲",
		"up-alt": "△",
		users: "\uD83D\uDC65",
		wheel: "⚙️"
	},
	it : {
		"Active":"Attivo",
		"Add...": "Aggiungi…",
		"Add user": "Aggiungi utente",
		"Administration":"Amministrazione",
		"All existing associations":"Tutte le associazioni esistenti",
		"Available CVEs":"CVE presenti",
		"Available perimeters":"Perimetri presenti",
		"Available simulations":"Simulazioni presenti",
		"Back":"Torna",
		"Blank":"Nessuna risposta",
		"Cancel" : "Annulla",
		"CannotAuthTitle":"Impossibile autenticarsi",
		"Changes":"Cambiamenti",
		"Checking":"Verifica",
		"Choose...":"Scegli…",
		"Close":"Chiudi",
		"Code":"Codice",
		"Completeness":"Avanzamento",
		"ConfirmCannotUndo":"Questa operazione non può essere annullata.\n\nProcedo?",
		"Continue":"Continua",
		"Create":"Crea",
		"Created":"Creato",
		"Creating perimeter":"Creazione del perimetro",
		"CreationDate":"Creazione",
		"Cve Explorer":"Match su CVE",
		"CveLoader":"Upload CVE",
		"Cycle":"Ciclo",
		"Date":"Data",
		"Default language": "Lingua di default",
		"Delete":"Elimina",
		"Delete all":"Elimina tutto",
		"Deleted":"Eliminato",
		"Description":"Descrizione",
		"Deselect":"Deseleziona",
		"Details":"Descrizione",
		"Done":"Fatto",
		"Drop a folder here, or click to choose":"Trascina qui una cartella, o click per selezionarla",
		"Download comprehensive archive":"Download dell’archivio completo",
		"Download page":"Pagina di download",
		"Duplicate":"Duplica",
		"Edit":"Modifica",
		"Edit Simulation":"Modifica simulazione",
		"Equivalences":"Equivalenze",
		"Error":"Errore",
		"Errors":"Errori",
		"External links":"Link esterni",
		"Falling nodes":"Nodi deteriorati",
		"False":"Falso",
		"Files":"File",
		"Filter":"Filtra",
		"Folder loader":"Caricamento di una cartella",
		"Folders":"Cartelle",
		"Graphic selector":"Selettore grafico",
		"Hide":"Nascondi",
		"History":"Storico",
		"Huge file size":"File di grandi dimensioni",
		"ICT good":"Bene ICT",
		"ICT goods":"Beni ICT",
		"Inactive":"Non attivo",
		"Info":"Informazioni",
		"LastLogin": "Ultimo login",
		"LastSeen": "Ultima attività",
		"LastUpdate":"Ultima modifica",
		"Link to an external site":"Link a un sito esterno",
		"Load":"Carica",
		"LoadedPF":"Caricate",
		"Loading":"Caricamento",
		"LogView":"Registro",
		"Main subject":"Soggetto principale",
		"Main subjects":"Soggetti principali",
		"MainMenu":"Menu principale",
		"Mandatory":"Obbligatorio",
		"Model":"Prodotto",
		"Name":"Nome",
		"Not configured":"Non configurato",
		"Never":"Mai",
		"New Simulation": "Nuova simulazione",
		"New user":"Nuovo utente",
		"No items found": "Nessun elemento trovato",
		"Nodes":"Nodi",
		"Note":"Nota",
		"Notes":"Note",
		"Notifications":"Notifiche",
		"Now":"Ora",
		"Number":"Numero",
		"on":"su",
		"Operation completed":"Operazione completata",
		"Operations":"Operazioni",
		"Operator":"Operatore",
		"Options":"Opzioni",
		"Page size":"Paginazione",
		"Perimeter":"Perimetro",
		"Perimeter data":"Dati del perimetro",
		"Perimeters":"Perimetri",
		"Priority":"Priorità",
		"Published":"Pubblicato",
		"Ready":"Pronto",
		"RejectedPF":"Respinte",
		"Reload":"Ricarica",
		"Remove":"Elimina",
		"Resource":"Risorsa",
		"Resources":"Risorse",
		"Retry":"Riprova",
		"Revert":"Ripristina",
		"Roles":"Ruoli",
		"Running":"Esecuzione",
		"Save":"Salva",
		"Saved":"Salvato",
		"Search":"Cerca",
		"Select":"Scegli",
		"SelectMulti":"Scegli…",
		"Settings":"Impostazioni",
		"Show":" Mostra",
		"Show hidden":"Mostra nascosti",
		"ShowNoRoles":"Includi disabilitati",
		"ShowNoRolesExtended":"Mostra anche gli utenti disabilitati - senza un ruolo assegnato",
		"Simulation":"Simulazione",
		"Simulation completed":"Simulazione completata",
		"Simulation start":"Avvio simulazione",
		"Simulation started":"Simulazione avviata",
		"Simulation steps" :"Passi della simulazione",
		"Simulations":"Simulazioni",
		"SimulationSettings":"Impostazione dei trigger",
		"SkippedPF":"Saltate",
		"superUser":"Super utente",
		"Sign in": "Accedi",
		"Simulation type":"Tipo di simulazione",
		"Start":"Avvia",
		"Start time":"Ora di avvio",
		"StrategicAssociations": "Associazioni (strategico)",
		"Subject":"Soggetto",
		"Subjects":"Soggetti",
		"Synthetic data":"Dati sintetici",
		"Synthetic data generation":"Generazione dati sintetici",
		"Synthetic data generator": "Generatore dati sintetici",
		"Time":"Ora",
		"Time elapsed":"Tempo speso",
		"total":"in totale",
		"Total size":"Dimensione totale",
		"TotItemsFound":"Risultati: {{tot|0}}",
		"True":"Vero",
		"Type":"Tipo",
		"Unanswered":"Nessuna risposta",
		"Unique ID":"ID univoco",
		"Unauthorized user":"Utente non autorizzato",
		"Unknown user":"Utente non censito",
		"Updated":"Aggiornato",
		"Upload real data":"Upload dati reali",
		"Upload synthetic data":"Upload dati sintetici",
		"User area":"Area utente",
		"Username":" Nome utente",
		"User":"Utente",
		"Users":"Utenti",
		"UsersManagement":"Gestione utenti",
		"Users view":"Elenco utenti",
		"Vendor":"Produttore",
		"Version":"Versione",
		"View":"Vedi",
		"Year":"Anno",
		"Yes":"Sì"
	},
	en: {
		"Add...": "Add…",
		"CannotAuthTitle":"Unable to authenticate",
		"Choose...":"Choose…",
		"ConfirmCannotUndo":"This action cannot be undone.\n\nShould I proceed?",
		"CreationDate":"Creation date",
		"Cve Explorer":"CVE match",
		"CveLoader":"CVE loader",
		"LastLogin": "Last login",
		"LastSeen": "Last action",
		"LastUpdate":"Last update",
		"LoadedPF":"Loaded",
		"LogView":"Log view",
		"MainMenu": "Main menu",
		"RejectedPF":"Rejected",
		"SelectMulti": "Select…",
		"ShowNoRoles":"Include disabled",
		"ShowNoRolesExtended":"Show also disabled users - e.g.: users without roles",
		"SimulationSettings":"Triggers settings",
		"SkippedPF":"Skipped",
		"StrategicAssociations": "Associations (strategic)",
		"TotItemsFound":"Items found: {{tot|0}}",
		"UsersManagement":"Users management",
	}
});

export default labels;
